export const siteConfig = {
  siteName: "Recon Calibration & Test Labs LLP",
  legalName: "Recon Calibration and Test Labs LLP",
  baseUrl: "https://www.reconcalibration.com",
  defaultTitle:
    "Calibration Services in Pune | Calibration Services in India | Recon Calibration & Test Labs LLP",
  defaultDescription:
    "Get ISO/IEC 17025:2017 NABL accredited calibration services in Pune and across India with accurate results, complete traceability, and nationwide support.",
  defaultImage: "https://www.reconcalibration.com/img/gall56.webp",
  logo: "https://www.reconcalibration.com/img/logo.png",
  email: "sales@reconcalibration.com",
  schemaPhone: "+91-8530777540",
  phonePrimary: "+91-8530777540",
  phoneSecondary: "+91-8087667057",
  phoneDisplay: ["(+91) 8530777540", "(+91) 8087667057"],
  whatsappNumber: "918530777540",
  whatsappMessage:
    "Hello Recon Calibration & Test Labs LLP, I would like to enquire about your calibration services.",
  googleSiteVerification: "ZKBjJAUPh9dbmDo8AcOf3NEHMHS2u54DJVIpdOM7z5I",
  googleAnalyticsId: "G-XYFEYJLM5T",
  address: {
    streetAddress: "Plot No. PAP-3, Near Appu Garage, MIDC Indrayaninagar",
    addressLocality: "Pune",
    addressRegion: "Maharashtra",
    postalCode: "411026",
    addressCountry: "IN",
  },
  geo: {
    latitude: "18.6738",
    longitude: "73.7790",
  },
  areaServed: "India",
  foundingDate: "2019",
  taxId: "27ABIFR0453P1ZP",
  priceRange: "₹₹",
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d130118.0282587057!2d73.76489252382987!3d18.633947329320605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b9006e71acfb%3A0xb70829c00871c203!2sRecon%20Calibration%20and%20Test%20Labs%20LLP!5e1!3m2!1sen!2sin!4v1782479604746!5m2!1sen!2sin",
  mapDirectionsUrl:
    "https://www.google.com/maps/search/?api=1&query=Plot%20No%20Pap-3%2C%20MIDC%2C%20Indrayaninagar%2C%20Bhosari%2C%20Pune%20411026",
  socialLinks: {
    linkedin: "",
    facebook: "",
    instagram: "",
  },
};

export const absoluteUrl = (path = "/") => {
  if (!path || path === "/") {
    return `${siteConfig.baseUrl}/`;
  }

  return `${siteConfig.baseUrl}${path.startsWith("/") ? path : `/${path}`}`;
};

export const assetUrl = (assetPath = "") => {
  const normalizedPath = assetPath
    .replace(/^\.?\//, "")
    .replace(/^public\//, "");

  return absoluteUrl(`/${normalizedPath}`);
};

export const phoneHref = (phoneNumber = "") =>
  `tel:${phoneNumber.replace(/[^+\d]/g, "")}`;

export const mailHref = (email = siteConfig.email) => `mailto:${email}`;

export const whatsappUrl = () =>
  `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(
    siteConfig.whatsappMessage
  )}`;
